import React from "react"

function Receipt(props) {
  const {
    accountName,
    accountPhone,
    accountEmail,
    accountStreet,
    accountCity,
    accountState,
    accountZip,
    firstName,
    lastName,
    address,
    city,
    state,
    zip,
    orderId,
    amountPaid: totalAmount,
    // process,
    // paymentType,
    last4,
    // cardType,
    authCode,
    avsResponse,
    // invoiceUrl,
    termsAndConditions,
    capture_signature,
    surchargeFee,
    surchargeMessage,
    hideHeader = false,
    synchronyPromoCode,
    synchronyPromoDescr,
    paymentDate,
    canClosePage,
    hexColorCode,
  } = props
  const paymentDateLoc = new Date(paymentDate).toLocaleString("en-US", {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    timeZoneName: "short",
  })
  
  let {
    cardType,
    paymentType
  } = props
  cardType = cardType ? cardType.charAt(0).toUpperCase() + cardType.slice(1) : ''
  paymentType = paymentType ? paymentType.charAt(0).toUpperCase() + paymentType.slice(1) : ''

  const handleClose = () => {
    window.close()
  }

  const formatPhoneNumber = (phone) => {
    if (!phone) return ""
    
    // Remove all non-numeric characters
    let cleaned = phone.replace(/\D/g, "")
  
    // Remove country code if it's 11 digits and starts with "1"
    if (cleaned.length === 11 && cleaned.startsWith("1")) {
      cleaned = cleaned.substring(1)
    }
  
    // Ensure it's a 10-digit number
    if (cleaned.length !== 10) return phone
  
    // Format as (999) 999-9999
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`
  }

  let {
    payWithACH, 
  } = props
  if (payWithACH === undefined || payWithACH === null) payWithACH = false
  console.log('in receipt', payWithACH, surchargeFee, surchargeMessage,synchronyPromoCode,synchronyPromoDescr)
  let subtotal = surchargeFee ? totalAmount - surchargeFee : totalAmount
  const { accountImage, ...filteredProps } = props
  console.log('in receipt' + JSON.stringify(filteredProps))
  return (
    <div className="container-fluid">
      {!hideHeader && canClosePage && (
        <div className="row justify-content-center" style={{ marginBottom: "20px" }}> 
          <button
            onClick={handleClose}
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              width: "34px",
              height: "34px",
              backgroundColor: "Gainsboro",
              color: "red",
              border: "none",
              borderRadius: "4px",
              fontSize: "18px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "red"
              e.target.style.color = "white"
              e.target.title = "Close Page"
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "Gainsboro"
              e.target.style.color = "red"
            }}
            >
              ✕
          </button>
        </div>
      )}
      {!hideHeader && accountImage && (
        <div className="row justify-content-center">
          <div className="col-5 mt-2 mh-100">
            <img src={accountImage} alt="image" className="rounded img-fluid border"/>
          </div>
        </div>
      )}
      { !hideHeader && <h2 style={{ color: hexColorCode || 'inherit' }}><b>{accountName}</b></h2>}
      { !hideHeader && <h7>{accountStreet}<br/></h7>}
      { !hideHeader && <h7>{accountCity}, {accountState} {accountZip}<br/></h7>}
      { !hideHeader && <h7>{formatPhoneNumber(accountPhone)}<br/></h7>}
      { !hideHeader && <h7>{accountEmail}</h7>}

      <div className="col justify-content-center">
        <div className="card bg-light mt-2">
          <div className="card-header">
            Receipt of Payment
          </div>
          <div className="card-body">
            <div className="container text-start">
              <div className="row">
                <div className="col-6">
                  <div className="row">
                    <div className="col-12">
                      <b>Name</b>
                    </div> 
                  </div>
                  <div className="row">
                    <div className="col-12">
                    {firstName} {lastName}
                    </div> 
                  </div>
                  {!hideHeader && (
                    <div className="row">
                      <div className="col-12">
                        <b>Address</b>
                      </div> 
                    </div>
                  )}
                  {!hideHeader && (
                    <div className="row">
                      <div className="col-12">
                        <div className="row">
                          <div className="col-12">
                          {address}
                          </div> 
                        </div>
                        <div className="row">
                          <div className="col-12">
                            {city} {state}, {zip}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="row">
                    <div className="col-12">
                      <b>Card Type</b>
                    </div> 
                  </div>
                  <div className="row">
                    <div className="col-12">
                    { payWithACH ?  (
                      <div>ach</div>
                    ) : <div>{ cardType }</div> }
                    </div> 
                  </div>

                  { synchronyPromoCode && (
                    <div>
                    <div className="row">
                      <div className="col-12">
                        <b>Synchrony Promo</b>
                      </div> 
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <div>{ synchronyPromoCode } - { synchronyPromoDescr }</div>
                      </div> 
                    </div>
                  </div>
                  )}

                  <div className="row">
                    <div className="col-12">
                    { payWithACH ?  (
                      <b></b>
                    ) : <b>Card #</b> }
                    </div> 
                  </div>
                  <div className="row">
                    <div className="col-12">
                      {last4}
                    </div> 
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <b>Type</b>
                    </div> 
                  </div>
                  <div className="row">
                    <div className="col-12">
                      {paymentType}
                    </div> 
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <b>Approval Code</b>
                    </div> 
                  </div>
                  <div className="row">
                    <div className="col-12">
                      {authCode}
                    </div> 
                  </div>
                </div>
                <div className="col-6">
                  <div className="row">
                    <div className="col-12">
                    <b>Invoice</b>
                    </div> 
                  </div>
                  <div className="row">
                    <div className="col-12">
                      {/* {invoiceUrl ? (<a href={invoiceUrl}>Link</a>) : '' } */}
                      {orderId}
                    </div> 
                  </div>
                  { surchargeFee && (
                    <div className="row">
                      <div className="col-12">
                        <b>Amount</b>
                      </div> 
                    </div>
                  )}
                  { surchargeFee && (
                    <div className="row">
                      <div className="col-12">
                        {new Intl.NumberFormat('en-US',
                          { style: 'currency', currency: 'USD',
                            minimumFractionDigits: 2 }).format(subtotal)}
                      </div> 
                    </div>
                  )}
                  { surchargeFee && (
                    <div className="row">
                      <div className="col-12">
                        <b>Fee*</b>
                      </div> 
                    </div>
                  )}
                  { surchargeFee && (
                    <div className="row">
                      <div className="col-12">
                        {new Intl.NumberFormat('en-US',
                          { style: 'currency', currency: 'USD',
                            minimumFractionDigits: 2 }).format(surchargeFee)}
                      </div> 
                    </div>
                  )}
                  <div className="row">
                    <div className="col-12">
                      <b>Total Amount</b>
                    </div> 
                  </div>
                  <div className="row">
                    <div className="col-12">
                      {new Intl.NumberFormat('en-US',
                        { style: 'currency', currency: 'USD',
                          minimumFractionDigits: 2 }).format(totalAmount)}
                    </div> 
                  </div>
                  
                  
                  <div className="row">
                    <div className="col-12">
                      <b>AVS Response</b>
                    </div> 
                  </div>
                  <div className="row">
                    <div className="col-12">
                      {avsResponse}
                    </div> 
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <b>Transaction Date</b>
                    </div> 
                  </div>
                  <div className="row">
                    <div className="col-12">
                      {paymentDateLoc}
                    </div> 
                  </div>
                  
                </div>
              </div>
            
              <div className="row">
                <div className="col-6 mt-1">
                  {termsAndConditions ? (<p >{termsAndConditions}</p>) : ''}
                </div>
              </div>
              <div className="row">
                <div className="col-6 mt-1">
                  {capture_signature ? ( <img src={capture_signature} alt="image" className="img-fluid m-1"/>) : ''}
                </div>
              </div>
              { surchargeFee && (
                <div className="row">
                  <div className="col-12 mt-1">
                    <b>*</b>{surchargeMessage}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Receipt


